import React, { useState, useEffect } from "react";
import "./AdminRegister.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";

function AdminRegister() {
  const navigate = useNavigate();

  const adminId = localStorage.getItem("adminId");

  const token = localStorage.getItem("token");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      if (adminId) {
        navigate("/admin-auth/profile");
      }
    }
  }, [token]);

  function loginValidation() {
    if (email.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (password.length < 1) {
      toast.error("Password is required");
      return false;
    }

    return true;
  }

  const handleLogin = async (e) => {
    e.preventDefault();

    const validate = await loginValidation();

    if (validate) {
      const data = {
        email,
        password,
      };
      setLoading(true);
      const toastLoading = toast.loading("Signing in...");
      try {
        const response = await fetch(`${API}/auth/admins/admin-login`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Signed in successfully");
          setLoading(false);
          await localStorage.removeItem("token");
          await localStorage.removeItem("laId");
          await localStorage.removeItem("laEmail");
          await localStorage.removeItem("laName");
          await localStorage.removeItem("laPhone");
          await localStorage.removeItem("laState");
          await localStorage.removeItem("token");
          await localStorage.removeItem("agentId");
          await localStorage.removeItem("agentEmail");
          await localStorage.removeItem("agentName");
          await localStorage.removeItem("agentPhone");

          await localStorage.removeItem("agentVendorType");
          await localStorage.removeItem("agentState");
          await localStorage.removeItem("agentZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("userId");
          await localStorage.removeItem("userEmail");
          await localStorage.removeItem("userName");
          await localStorage.removeItem("userPhone");
          await localStorage.removeItem("userZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("advertiserId");
          await localStorage.removeItem("email");
          await localStorage.removeItem("name");
          await localStorage.removeItem("phone");
          await localStorage.removeItem("zipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("adminId");
          await localStorage.removeItem("adminEmail");
          await localStorage.removeItem("adminName");
          await localStorage.removeItem("adminPhone");
          await localStorage.removeItem("token");
          await localStorage.removeItem("addhypeId");
          await localStorage.removeItem("addhypeEmail");
          await localStorage.removeItem("addhypeName");
          await localStorage.removeItem("addhypePhone");
          if (json.admin.role === "superAdmin" || json.admin.role === "admin") {
            localStorage.setItem("token", json.token);
            localStorage.setItem("adminId", json.admin._id);
            localStorage.setItem("adminEmail", json.admin.email);
            localStorage.setItem("adminName", json.admin.name);
            localStorage.setItem("adminPhone", "123456789");
            localStorage.setItem("adminRole", json.admin.role);

            navigate("/admin-auth/profile");
          }
          if (json.admin.role === "addhype") {
            localStorage.setItem("token", json.token);
            localStorage.setItem("addhypeId", json.admin._id);
            localStorage.setItem("addhypeEmail", json.admin.email);
            localStorage.setItem("addhypeName", json.admin.name);
            localStorage.setItem("addhypePhone", "123456789");

            navigate("/addhype-auth/profile");
          }
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.dismiss(toastLoading);
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="agent-register-section">
      <NavbarComponent />

      <div className="container-fluid agent-register-container px-0">
        <div className="row px-0 mx-0">
          <div className="col-lg-6 agent-register-form-conatiner d-flex justify-content-center">
            <h2 className="agent-register-heading">Admin Login</h2>

            <form className="agent-register-form">
              <input
                type="email"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />

              <input
                type="password"
                className="form-control agent-register-input-field"
                id="exampleInputPassword1"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />

              <button
                onClick={handleLogin}
                className="btn agent-register-button"
              >
                Sign In
              </button>
            </form>
          </div>
          <div className="col-lg-6 px-0 d-none d-lg-block">
            <div className="admin-signin-image-conatiner"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminRegister;
